




















































































































































































































































import { Component } from 'vue-property-decorator';
import { Base } from '../common/base';
import { RepairOrderCustomerInfoViewModel } from '@/models/fixedops/repairorder';
import { customerService } from '@/shared';

@Component({
  watch: {
    customerInfo(newVal, oldVal) {
      this.getCustomerInfo(newVal);
    },
  },
  props: ['customerInfo'],
})
export default class CustomerInformationComponent extends Base {
  public customerInfo: RepairOrderCustomerInfoViewModel;
  public isLoaded: boolean = false;
  public iscustomerInformationLoading: boolean = false;

  public mounted(): void {
    // mounted
  }

  public close(): void {
    this.$emit('onClose');
  }

  public async getCustomerInfo(
    model: RepairOrderCustomerInfoViewModel
  ): Promise<void> {
    try {
      this.iscustomerInformationLoading = true;
      this.isLoaded = false;
      const response = await customerService.getCustomerInfoAsync(
        model.customerKey
      );

      const keys = Object.keys(response);
      keys.forEach((key) => {
        model[key] = response[key];
      });
      this.customerInfo = model;
      this.isLoaded = true;
    } catch (e) {
      this.close();
    } finally {
      this.iscustomerInformationLoading = false;
    }
  }
}
